<template>
  <div id="home">
    <div class="header">
      <div class="log"></div>
      <div class="login" @click="loginFn" v-if="!isLogin">
        <img class="login_bg" src="../assets/images/user.png" alt />
        {{ $t("message.strid1") }}
      </div>
      <div class="login" @click="logout" v-if="isLogin">{{ userName }}</div>
      <div class="lang" @click="showMask = true">
        <img class="lang_bg" src="../assets/images/lang.png" alt />
        {{ langText }}
      </div>
    </div>
    <div class="bigtitle">{{ $t("message.strid29") }}</div>
    <div class="content">
      <p class="swiper_title">{{ $t("message.strid2") }}</p>
      <div class="swiper-container">
        <div class="swiper-wrapper">
          <div class="swiper-slide" v-for="item in banner_data" :key="item">
            <a :href="item.link_url" target="_blank" rel="noopener noreferrer">
              <img :src="item.pic_url" alt />
            </a>
          </div>
        </div>
        <div class="swiper-pagination"></div>
      </div>
      <ul class="punishList">
        <li class="item" v-for="item in punish_data" :key="item">
          <router-link :to="{ path: 'punishWeek', query: { id: item.id } }">
            <p class="item_title">{{ item.title }}</p>
            <p class="item_time">{{ item.created_at }}</p>
          </router-link>
        </li>
      </ul>
      <router-link to="/announcement">
        <div class="moreBtn">{{ $t("message.strid3") }}</div>
      </router-link>
    </div>
    <a class="routerlink punish" @click="routerPush('/punish')">
      <img class="punishimg" src="../assets/images/punish.png" alt />
      <div>{{ $t("message.strid4") }}</div>
    </a>
    <a class="routerlink appeal" @click="routerPush('/appeal')">
      <img class="appealimg" src="../assets/images/report.png" alt />
      <div>{{ $t("message.strid5") }}</div>
    </a>

    <MTmask :show.sync="showMask">
      <div class="langBox">
        <div
          class="langBtn"
          :class="lang == 'en' ? 'active' : ''"
          @click="choseLan('en', 'EN')"
        >
          English
        </div>
        <div
          class="langBtn"
          :class="lang == 'ph' ? 'active' : ''"
          @click="choseLan('ph', 'PH')"
        >
          Pilipino
        </div>
        <div
          class="langBtn"
          :class="lang == 'id' ? 'active' : ''"
          @click="choseLan('id', 'ID')"
        >
          Indonesian
        </div>
        <div
          class="langBtn"
          :class="lang == 'mm' ? 'active' : ''"
          @click="choseLan('mm', 'MM')"
        >
          ဗမာ
        </div>
        <div
          class="langBtn"
          @click="choseLan('pt', 'BR')"
          :class="lang == 'pt' ? 'active' : ''"
        >
          Portugal
        </div>
        <div
          class="langBtn"
          @click="choseLan('ru', 'RU')"
          :class="lang == 'ru' ? 'active' : ''"
        >
          русский
        </div>
      </div>
    </MTmask>
  </div>
</template>

<script>
import {
  abort,
  indexList,
  setUserToken,
  getBaseInfo,
  getCode,
} from "@/proxy/index";
import { getParam } from "@/util/index";
import MTmask from "@/components/Mask";

export default {
  components: {
    MTmask,
  },
  data() {
    return {
      isLogin: false,
      languageList: [
        {
          label: "EN",
          value: "en",
        },
        {
          label: "ID",
          value: "id",
        },
        {
          label: "RU",
          value: "ru",
        },
        {
          label: "MM",
          value: "mm",
        },
        {
          label: "PH",
          value: "ph",
        },
        {
          label: "BR",
          value: "pt",
        },
      ],
      lanList: ["en", "ph", "pt", "ru", "mm", "id"],
      lang: "en",
      Mlog: null,
      loginObj: null,
      linkInfo: {},
      inviteCode: "invite",
      showMask: false,
      class_: "",
      banner_data: [],
      punish_data: [],
      userName: "",
      errCode: {},
      langText: "EN",
    };
  },
  mounted() {
    const lan = window.localStorage.getItem("selfservicelang");
    if (lan) {
      const i = this.languageList.find((item) => item.value == lan);
      if (i) {
        this.lang = i.value;
        this.choseLan(lan, i.label);
      }
    } else {
      this.lang = "en";
      this.$i18n.locale = "en";
    }

    //取消请求
    this.linkInfo = getParam();

    this.Mlog = new Mlog({
      activity: process.env.VUE_APP_NAME,
    });

    try {
      this.Mlog.visitLog({
        behavior: "visit",
        referee: this.linkInfo.o || "",
      });
    } catch (error) {
      //
    }

    this.loginObj = new $autologin({});
    if (Cookies.get("token")) {
      this.isLogin = true;
      this.nickname = Cookies.get("userId");
      this.token = Cookies.get("token");
      this.getBaseInfo(this.token, Cookies.get("jwt"));
    }

    document.querySelector("#loadingMask").style.display = "none";

    this.loginObj.on("loginSucc", (res) => {
      const lang = this.findLangCode(res.data.clientlang);
      const i = this.languageList.find((item) => item.value == lang);
      if (i) {
        window.localStorage.setItem("selfservicelang", lang);
        this.choseLan(lang, i.label);
        this.loginObj.changeLang(lang);
      }
      this.setUserToken();
      this.isLogin = true;
      this.token = res.data.data.token;
      this.getBaseInfo(this.token, res.data.data.jwt);
    });

    this.loginObj.on("logoutSucc", (res) => {
      this.logoutFn();
    });

    this.loginObj.on("closeFriendInvite", (res) => {});
    this.loginObj.on("inviteFriendSucc", (res) => {});
    this.loginObj.on("inviteFriendFail", (res) => {});
    this.getList();
    window.localStorage.setItem("selfservicelang", this.lang);
    this.getCode(this.lang);
    // this.SwiperFn();
  },
  methods: {
    getCode(lang) {
      getCode(lang).then((res) => {
        (res.data.errcode || []).map((item) => {
          this.errCode[item.code] = item.lang || "";
        });
      });
    },
    findLangCode(code) {
      const obj = {
        101: "en",
        109: "id",
        113: "jp",
        180: "kh",
        123: "mm",
        115: "my",
        104: "pt_BR",
        103: "ru",
        108: "tr",
        116: "zh_TW",
        112: "vn",
      };
      return obj[code] || "en";
    },
    getList() {
      indexList(this.lang).then((res) => {
        if (res.data.code == 0) {
          this.banner_data = res.data.data.banner_data;
          this.punish_data = res.data.data.punish_data;
          this.SwiperFn();
        } else {
          layer.open({
            content: this.errCode[res.data.code] || res.data.code,
            skin: "msg",
            time: 2,
          });
        }
      });
    },
    setUserToken() {
      setUserToken(this.lang, Cookies.get("token")).then((res) => {
        console.log(1);

        if (res.data.code == 0) {
          this.isLogin = true;
        } else {
          layer.open({
            content: this.errCode[res.data.code] || res.data.code,
            skin: "msg",
            time: 2,
          });
        }
      });
    },
    SwiperFn() {
      this.$nextTick(() => {
        new Swiper(".swiper-container", {
          // autoplay: true,
          loop : true,
          autoplay: {
            disableOnInteraction: false,
            delay: 3000,
          },
          pagination: {
            el: ".swiper-pagination",
          },
          observer: true,
          observeParents: true,
          observeSlideChildren: true,
        });
      });
    },
    routerPush(href) {
      if (!this.isLogin) {
        this.loginFn();
        return false;
      } else {
        this.$router.push({
          path: href,
        });
      }
    },
    clearParams() {
      this.linkInfo = {};
      try {
        history.pushState(null, null, window.location.href.split("?")[0]);
      } catch (error) {
        window.location.href = window.location.href.split("?")[0];
      }
    },
    loginFn() {
      this.loginObj.loadIframe();
    },
    getBaseInfo(token,jwt) {
      getBaseInfo(token,jwt).then((res) => {
        if (res.data.code == 0) {
          this.userName = res.data.data.name;
          Cookies.set("userName", this.userName);
        }
      });
    },
    logoutFn() {
      this.isLogin = false;
      Cookies.remove("userId");
      Cookies.remove("userGroup");
      Cookies.remove("token", { express: 0.5 });
    },
    logout() {
      this.loginObj.showLogout();
    },
    choseLan(lang, text) {
      this.langText = text;
      this.lang = lang;
      this.$i18n.locale = lang;
      this.showMask = false;
      window.localStorage.setItem("selfservicelang", this.lang);
      if (this.isLogin) {
        this.loginObj.changeLang(lang);
      }
      this.getCode(this.lang);
      this.getList();
      // this.SwiperFn();
    },
  },
};
</script>

<style lang="scss">
@import "~@/assets/scss/views/home.scss";
</style>
